import { object, string, number, literal, z } from 'zod'

export const countryValidationSchema = object({
  iso2: string().min(1, { message: 'common.validation.mandatory' }),
  name: string().min(1, { message: 'common.validation.mandatory' }),
  phone_code: string({ required_error: ' ' }).min(1, { message: ' ' }),
})

export const phoneValidationSchema = object(
  {
    number: number({ required_error: 'common.validation.mandatory' }).min(1, {
      message: 'common.validation.mandatory',
    }),
    country: countryValidationSchema,
  },
  { required_error: 'common.validation.mandatory' }
).superRefine(({ country: { phone_code }, number }, ctx) => {
  if (!useValidatePhone(number, phone_code)) {
    ctx.addIssue({
      path: ['phone', 'phone.country.phone_code'],
      code: 'custom',
      message: 'common.validation.invalidPhone',
    })
  }
})

export const nameValidationSchema = string({ required_error: 'common.validation.mandatory' }).min(2, {
  message: 'common.validation.minChars',
})

const emptyStringToUndefined = literal('').transform(() => undefined)

export function asOptionalField<T extends z.ZodTypeAny>(schema: T) {
  return schema.optional().or(emptyStringToUndefined)
}
